// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    profile: `${ROOTS.DASHBOARD}/profile`, // Nueva ruta para Mi perfil
    medias: {
      root: `${ROOTS.DASHBOARD}/medias`,
      new: `${ROOTS.DASHBOARD}/medias/new`,
      details: (id: number) => `${ROOTS.DASHBOARD}/medias/${id}`,
      categories: `${ROOTS.DASHBOARD}/medias/categories`,
      importMedia: `${ROOTS.DASHBOARD}/medias/import-media`,
      packs: {
        root: `${ROOTS.DASHBOARD}/medias/packs`,
        new: `${ROOTS.DASHBOARD}/medias/packs/new`,
        details: (id: number) => `${ROOTS.DASHBOARD}/medias/packs/${id}`,
        edit: (id: number) => `${ROOTS.DASHBOARD}/medias/packs/${id}/edit`,
      },
    },
    tools: {
      root: `${ROOTS.DASHBOARD}/tools`,
      coupons: {
        root: `${ROOTS.DASHBOARD}/tools/coupons`,
      },
      calendar: {
        root: `${ROOTS.DASHBOARD}/tools/calendar`,
      },
      mediaProposals: {
        root: `${ROOTS.DASHBOARD}/tools/media-proposals`,
        new: `${ROOTS.DASHBOARD}/tools/media-proposals/new`,
        details: (id: number) => `${ROOTS.DASHBOARD}/tools/media-proposals/${id}`,
      },
      profitManagement: {
        root: `${ROOTS.DASHBOARD}/tools/profit-management`,
        gmb: {
          new: `${ROOTS.DASHBOARD}/tools/profit-management/gmb/new`,
          edit: (id: number) => `${ROOTS.DASHBOARD}/tools/profit-management/gmb/${id}/edit`,
        },
        pressRelease: {
          new: `${ROOTS.DASHBOARD}/tools/profit-management/press-release/new`,
          edit: (id: number) =>
            `${ROOTS.DASHBOARD}/tools/profit-management/press-release/${id}/edit`,
        },
        gmbBooster: {
          new: `${ROOTS.DASHBOARD}/tools/profit-management/gmb-booster/new`,
          edit: (id: number) => `${ROOTS.DASHBOARD}/tools/profit-management/gmb-booster/${id}/edit`,
        },
        localCitation: {
          new: `${ROOTS.DASHBOARD}/tools/profit-management/local-citation/new`,
          edit: (id: number) =>
            `${ROOTS.DASHBOARD}/tools/profit-management/local-citation/${id}/edit`,
        },
      },
      mailgun: {
        root: `${ROOTS.DASHBOARD}/tools/mailgun`,
        templates: {
          root: `${ROOTS.DASHBOARD}/tools/mailgun/templates`,
          new: `${ROOTS.DASHBOARD}/tools/mailgun/templates/new`,
          details: (name: string) => `${ROOTS.DASHBOARD}/tools/mailgun/templates/${name}`,
          edit: (name: string) => `${ROOTS.DASHBOARD}/tools/mailgun/templates/${name}/edit`,
        },
      },
      categoryAnalyzer: {
        root: `${ROOTS.DASHBOARD}/tools/category-analyzer`,
      },
      newsletterAdsRequests: {
        root: `${ROOTS.DASHBOARD}/tools/newsletter-ads-requests`,
        details: (id: number) => `${ROOTS.DASHBOARD}/tools/newsletter-ads-requests/${id}`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/orders`,
      details: (id: number) => `${ROOTS.DASHBOARD}/orders/${id}`,
      externals: {
        root: `${ROOTS.DASHBOARD}/orders/externals`,
        new: `${ROOTS.DASHBOARD}/orders/externals/new`,
        edit: (id: number) => `${ROOTS.DASHBOARD}/orders/externals/${id}/edit`,
        pendingPayments: `${ROOTS.DASHBOARD}/orders/externals/pending-payments`,
      },
    },
    billing: {
      platforms: {
        root: `${ROOTS.DASHBOARD}/billing/platforms`,
        details: (id: number) => `${ROOTS.DASHBOARD}/billing/platforms/${id}`,
        new: `${ROOTS.DASHBOARD}/billing/platforms/new`,
      },
    },
    outreach: {
      root: `${ROOTS.DASHBOARD}/outreach`,
      details: (id: number) => `${ROOTS.DASHBOARD}/outreach/${id}`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/outreach/${id}/edit`,
    },
    invoices: {
      root: `${ROOTS.DASHBOARD}/invoices`,
      llc: `${ROOTS.DASHBOARD}/invoices/llc`,
      new: `${ROOTS.DASHBOARD}/invoices/new`,
      details: (id: number) => `${ROOTS.DASHBOARD}/invoices/${id}`,
      expenses: {
        root: `${ROOTS.DASHBOARD}/invoices/expenses`,
        new: `${ROOTS.DASHBOARD}/invoices/expenses/new`,
        details: (id: number) => `${ROOTS.DASHBOARD}/invoices/expenses/${id}`,
      },
      paymentRequests: {
        root: `${ROOTS.DASHBOARD}/invoices/payment-requests`,
        details: (id: number) => `${ROOTS.DASHBOARD}/invoices/payment-requests/${id}`,
      },
    },
    customer: {
      root: `${ROOTS.DASHBOARD}/customers`,
      list: `${ROOTS.DASHBOARD}/customers/list`,
      details: (id: number) => `${ROOTS.DASHBOARD}/customers/${id}`,
    },
    adminUsers: {
      root: `${ROOTS.DASHBOARD}/admin-users`,
      new: `${ROOTS.DASHBOARD}/admin-users/new`,
      details: (id: number) => `${ROOTS.DASHBOARD}/admin-users/${id}`,
    },
    pendingJournalists: {
      root: `${ROOTS.DASHBOARD}/pending-journalists`,
      details: (id: number) => `${ROOTS.DASHBOARD}/pending-journalists/${id}`,
    },
    banners: {
      root: `${ROOTS.DASHBOARD}/banners`,
      new: `${ROOTS.DASHBOARD}/banners/new`,
      details: (id: number) => `${ROOTS.DASHBOARD}/banners/${id}`,
    },
    managedServices: {
      root: `${ROOTS.DASHBOARD}/managed-services`,
      details: (id: number) => `${ROOTS.DASHBOARD}/managed-services/${id}`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/managed-services/${id}`,
    },
    editorManagement: {
      root: `${ROOTS.DASHBOARD}/editor-management`,
      pendingMedias: `${ROOTS.DASHBOARD}/editor-management/pending-medias`,
      newsletters: {
        root: `${ROOTS.DASHBOARD}/editor-management/newsletters`,
        new: `${ROOTS.DASHBOARD}/editor-management/newsletters/new`,
        details: (id: number) => `${ROOTS.DASHBOARD}/editor-management/newsletters/${id}`,
        edit: (id: number) => `${ROOTS.DASHBOARD}/editor-management/newsletters/${id}/edit`,
      },
    },
    moderation: {
      root: `${ROOTS.DASHBOARD}/moderation`,
      messages: `${ROOTS.DASHBOARD}/moderation/messages`,
      bannedWords: `${ROOTS.DASHBOARD}/moderation/banned-words`,
    },
  },
};
